// @flow
import styled from 'styled-components';
import { p, mb } from 'styled-components-spacing';
import breakpoint from 'styled-components-breakpoint';
import { fontLinkNoStyles, fontTeaserBold, fontTeaserItalic } from '@styles/typography';

import theme from '@theme';

const { shadows, borderRadius, colors } = theme;

export const StyledWrapper = styled.a`
  ${borderRadius.default}
  ${shadows.default}
  overflow: hidden;
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  text-decoration: none;
`;

export const StyledCopyContainer = styled.div`
  ${fontLinkNoStyles}
  flex: 1 1 auto;
  display: flex;
  align-items: flex-end;
  ${p(3)}
`;

export const StyledCopy = styled.h4`
  ${fontTeaserBold}
  color: ${colors.darkBlue};
`;

export const StyledDate = styled.span`
  ${fontTeaserItalic}
`;

export const StyledLead = styled.p`
  font-size: 16px;
  color: ${colors.gray};

  ${mb(2)};
`;

export const StyledImgixWrapper = styled.div`
  width: 100%;
  height: 230px;
  ${breakpoint('tablet')`
    height: 493px;
  `}

  ${breakpoint('desktop')`
    height: 230px;
  `}
`;
